module.exports = __webpack_public_path__ + "static/img/phone.e670e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/software/images/phone.png
// module id = L99L
// module chunks = 1